
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's053c80dfb273b703': str`Photo of the institution`,
's130d574b67f1fd9b': str`Favorites`,
's1ac8916da1fbf5d6': str`Back to home`,
's1c703460a5da79b1': str`Rorder to the left`,
's24da9cfa1f59b900': str`No service`,
's26883f1a61fd0699': str`See all resources`,
's306320e48e15d90b': str`An error occurred while retrieving information from the service.
Please try reopening this file.`,
's358106e7a82ecfb0': str`Search`,
's3aeb7a7330a293db': str`Clear search`,
's3c031e6c4c978ff6': str`Close notification drawer`,
's3ee5c5545dbd01f8': str`Notification drawer`,
's49283da0ddbeccc2': str`Favorites menu`,
's49e765aed0087b0e': str`Email`,
's4c45c541dc69732e': str`Start tutorial`,
's4e540c9cd0860d6c': str`No ${0} favorite`,
's5261563ad59a1fae': str`Manage`,
's598ab55550d660f1': str`No results`,
's5be3c6d61cd9182f': str`Notifications`,
's5ee26933a140671a': str`Cancel`,
's602431f0eda0656c': str`Web site`,
's62c4468340ffb130': str`Close menu`,
's63d894b1ddb06289': str`Description`,
's6d8c02aee480af7a': str`Menu`,
's79d2f10870070403': str`Delete notification - ${0}`,
's7b37041836cc3169': str`You have`,
's7cdba3bb9574b540': str`Category`,
's7d6fe3c46c5ad168': str`Search for a service`,
's81489f3c55eb70cd': str`User menu`,
's8c72b686e1d78170': str`All services`,
's8e501f157694decd': str`Native service`,
's91fb0e685cae0940': str`Remove from favorites`,
's94c8acbfcc0796b5': str`no notification`,
's96cda4b0bdffb7b3': str`Delete ${0} notifications from ${1}`,
's97f93435ca295cf5': str`Institution`,
's9d6fd95b48299f31': str`Notification drawer`,
's9f48ad36dc7d460f': str`Add to favorites`,
'sa284edf05520f63f': str`Your favorites`,
'sadcdec056ba54dd9': str`Navigation drawer`,
'saeef3be08ad38e0f': str`No favorite service`,
'sb1ae6414f46b7471': str`My profile`,
'sba76902f0ee13f8d': str`In order for the change of institution to take effect, you must log out.

Do you agree to log out now?`,
'sbddc966a2760f55c': str`Change institution`,
'sc139bbab63351fe2': str`Access the ENT`,
'sc3a31f700d8e22a1': str`Logout`,
'sc9760fd20a454f56': str`Learn more`,
'sc9cc5c66b847c2fc': str`Phone number`,
'sd933c55b5ba171d6': str`Search ENT`,
'sdb9a884ccc06edf6': str`Delete favorite`,
'sdd2fffdf86bf5b6e': str`Address`,
'se1e9c7a19e8dd236': str`new`,
'se430513274f9b495': str`Save`,
'se627415befeda34d': str`Home`,
'se7036a0f025bd641': str`Institution information menu`,
'se831b27916e38e5f': str`Rorder to the right`,
'se9bc00ac86dcb50b': str`Available resources`,
'sef8481fc13f940c8': str`Institution information`,
'sf0da99a184bafb7e': str`Close`,
'sf52ce9bda73f60a6': str`An error occurred while retrieving services.
Try refreshing the page.`,
'sf55d634dcc743595': str`Services`,
'sfaa072ad346ce9d6': str`Launch service`,
'sfb9d2d8c7ef581a9': str`External service`,
'sfde5e3a793d980c1': str`First steps with the service`,
    };
  